// Step order + labels for the client-facing AEP renewal wizard (#656), which
// replaces the SurveyJS /survey/aep page for clients. The agent-facing
// /survey/{uid}/aep stays on SurveyJS (data/survey-aep.js) and is untouched —
// the same split #598 established between /checkup/* and /survey/{uid}/*.
//
// Paths mirror the MedicareCheckup platform's /renewal flow verbatim (the 16
// reference screenshots on #656), so the two products stay navigable by the
// same URLs. `welcome` and `done` bookend the run with `chrome: false`: the
// platform's landing screen shows no progress dots, and its first numbered
// dot is the contact step, so the steps between them are what the stepper
// counts (eight originally; seven since #656 merged doctors+hospitals).
import { makeWizard } from '~/data/wizard'

export const STEPS = [
    { id: 'welcome', path: '/renewal/welcome', label: 'Getting started', chrome: false },
    { id: 'contact', path: '/renewal/contact', label: 'Your details' },
    { id: 'current-plan', path: '/renewal/current-plan', label: 'Current plan' },
    // Doctors + hospitals share one page since #656 (comment 2 asked for the
    // merge in BOTH wizards); /renewal/hospitals redirects here.
    { id: 'providers', path: '/renewal/providers', label: 'Doctors & hospitals' },
    { id: 'medications', path: '/renewal/medications', label: 'Medications' },
    { id: 'pharmacy', path: '/renewal/pharmacy', label: 'Pharmacy' },
    { id: 'your-year', path: '/renewal/your-year', label: 'Your year' },
    { id: 'sign', path: '/renewal/sign', label: 'Review & sign' },
    { id: 'done', path: '/renewal/done', label: 'Done', chrome: false },
]

export const RENEWAL_WIZARD = makeWizard({
    id: 'renewal',
    basePath: '/renewal',
    steps: STEPS,
})
